import { CircularProgress } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../hooks";
import useBasicProfile from "../../hooks/useBasicProfile";
import { useRouter } from "../../hooks/useRouter";
import useTimeout from "../../hooks/useTimeout";
import { ROUTES } from "../../routes";
import { KeypairState } from "../../types/types";
import "./index.css";
import SignIn from "./Signin";
import KeyTransfer from "./KeyTransfer";

const KeypairPage = () => {
  const { t } = useTranslation();
  const { currentAddress } = useAppSelector((state) => state.auth);
  const { basicProfile: userProfile } = useBasicProfile(currentAddress);
  const { push, location } = useRouter();
  const theme = useTheme();
  const { pin, encryptedPrivateKey, keypairState } = useAppSelector(
    (state) => state.keys
  );
  const [isLoading, setIsLoading] = useState(true);
  const { clear: clearLoading, reset: resetLoading } = useTimeout(() => {
    setIsLoading(false);
  }, 400);
  useEffect(() => {
    clearLoading();
  }, []);
  useEffect(() => {
    setIsLoading(true);
    resetLoading();
  }, [keypairState, pin, encryptedPrivateKey, userProfile]);
  useEffect(() => {
    if (keypairState === KeypairState.KEYPAIR_SUCCESS) {
      setTimeout(() => {
        push(
          location.state?.from ? location.state?.from : ROUTES.WHITEBOARD_PAGE
        );
      }, 3000);
    }
  }, [keypairState]);
  const getUselessLoadingview = () => {
    if (isLoading)
      return (
        <div data-testid="loading-indicator">
          <CircularProgress style={{ color: theme.brandColor }} size={25} />
        </div>
      );
    else return getview();
  };
  const getview = useCallback(() => {
    if (keypairState === KeypairState.WAITING_KEY_AUTH) {
      if (!encryptedPrivateKey) {
        return <KeyTransfer />;
      } else {
        return <SignIn />;
      }
    }
    if (keypairState === KeypairState.KEYPAIR_SUCCESS) {
      return (
        <div
          data-testid="success-loading-indicator"
          className="kp-success-redirect"
        >
          <div>{t("PIN_Redirect_Message")}</div>
          <CircularProgress style={{ color: theme.brandColor }} size={25} />
        </div>
      );
    }
    return (
      <div data-testid="loading-indicator">
        <CircularProgress style={{ color: theme.brandColor }} size={25} />
      </div>
    );
  }, [keypairState, pin, encryptedPrivateKey, userProfile]);
  return <div className="kp-body-container">{getUselessLoadingview()}</div>;
};
export default KeypairPage;
